import {
  Brazil,
  China,
  Spain,
  UnitedStatesofAmerica,
} from "../../../assets/images";

import { LanguageItem } from "../types/i18n.types";

export const AVAILABLE_LANGUAGES: LanguageItem[] = [
  {
    value: "pt-BR",
    label: "Português",
    icon: Brazil,
  },
  {
    value: "en-US",
    label: "English",
    icon: UnitedStatesofAmerica,
  },
  {
    value: "es-ES",
    label: "Español",
    icon: Spain,
  },
  {
    value: "zh-CN",
    label: "中文",
    icon: China,
  },
];
